<template>
    <div>
        <div style="width: 90%; margin: auto; text-align: left">
            <p>更新日期：2024年3月28日</p>
            <p></p>
            <p>生效日期：2024年1月15日</p>
            <p></p>
            <p>
                欢迎使用钱小宝应用软件（以下简称"本软件"）！本软件尊重并保护所有用户的个人隐私权，会按照本隐私权政策的规定收集和使用你的个人信息。
            </p>
            <p></p>
            <p>1. 收集的信息</p>
            <p></p>
            <p>
                在你使用本软件服务的过程中，本软件会按照如下方式收集你在使用服务时主动提供或因为使用服务而产生的信息，用以向你提供服务、优化我们的服务以及保障你的帐号安全。
            </p>
            <p></p>
            <p>
                1.1
                当你使用记账提醒功能时，本软件会申请日历读写权限用于设置事件提醒。
            </p>
            <p></p>
            <p>
                1.2
                当你使用云端存储时，你的文件会以加密的形式存储在服务器，你可以随时删除这些文件。我们不会对外提供上述文件信息，或者将其用于该功能以外的其他用途。
            </p>
            <p></p>
            <p>2. 手机权限</p>
            <p></p>
            <p>
                2.1
                允许读取日历：android.permission.READ_CALENDAR。用于判断是否已设置记账提醒。
            </p>
            <p></p>
            <p>
                2.2
                允许写入日历：android.permission.WRITE_CALENDAR。用于设置记账提醒。
            </p>
            <p></p>
            <p>3. 信息的存储</p>
            <p></p>
            <p>3.1 信息存储的地点</p>
            <p></p>
            <p>我们会按照法律法规规定，将用户个人信息存储于中国境内。</p>
            <p></p>
            <p>3.2 信息存储的期限</p>
            <p></p>
            <p>
                我们仅在为实现目的所必需的时间内保留你的个人信息，当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知你，并在合理的期限内删除你的个人信息。
            </p>
            <p></p>
            <p>3.3 注销帐号</p>
            <p></p>
            <p>
                我们是个人记账工具，注册app即可添加个人账本信息，若您不想使用该软件，可注销帐号信息（注销后所有远端本地数据将会被清除），卸载后的所有本地信息将从服务端移除，此操作执行后立即生效，且不可恢复，请谨慎选择此操作。
            </p>
            <p></p>
            <p>4. 信息安全</p>
            <p></p>
            <p>
                4.1
                我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。
            </p>
            <p></p>
            <p>
                4.2
                我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术、匿名化处理等手段来保护你的个人信息。
            </p>
            <p></p>
            <p>
                4.3
                我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你设备本地完成部分信息加密的工作。
            </p>
            <p></p>
            <p>
                4.4
                我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。
            </p>
            <p></p>
            <p>
                4.5
                若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知你。
            </p>
            <p></p>
            <p>5. 条款变更</p>
            <p></p>
            <p>
                我们可能会适时对本隐私政策进行修订。当隐私条款发生变更时，我们会在你登录及版本更新时以推送通知、弹窗或其他适当形式向你展示变更后的条款。
            </p>
            <p></p>
            <p>6. 与我们联系</p>
            <p></p>
            <p>
                本软件著作权和隐私政策最终解释权归海南亿万未来科技有限公司所有。当你对本隐私政策有任何疑问或建议，欢迎通过邮件联系我们
                yiwanweilai@163.com，谢谢！
            </p>
            <p></p>
            <p>7. 第三方sdk</p>
            <p></p>
            <p>7.1 第三方SDK名称：友盟统计SDK-友盟同欣(北京)</p>
            <p></p>
            <p>运营方：友盟同欣（北京）科技有限公司</p>
            <p></p>
            <p>收集信息类型：</p>
            <p></p>
            <p>
                设备信息（IMEI/MAC/Android
                ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID/IP）
            </p>
            <p></p>
            <p>位置信息</p>
            <p></p>
            <p>网络信息</p>
            <p></p>
            <p>网络信息</p>
            <p></p>
            <p>已安装app信息</p>
            <p></p>
            <p>使用目的：</p>
            <p></p>
            <p>
                1.基于设备信息用于生成脱敏的终端用户设备标识，以确保提供SDK服务；
            </p>
            <p></p>
            <p>2.基于粗略位置用于区域维度的应用分析，提供地区数据报表；</p>
            <p></p>
            <p>3.基于应用列表实现应用安装与卸载统计。</p>
            <p></p>
            <p>隐私协议地址：https://www.umeng.com/page/policy</p>
            <p></p>
            <p>7.2 第三方SDK名称：快手联盟SDK</p>
            <p></p>
            <p>运营方：北京快手科技有限公司</p>
            <p></p>
            <p>收集信息类型：</p>
            <p></p>
            <p>设备信息（IMEI, MEID, OAID. Androidld, IMSI, ICCID）</p>
            <p></p>
            <p>
                位置信息 (IP地址、MAC 地址、GPS 位置信息、基站信息、WIFI 信息)
            </p>
            <p></p>
            <p>应用安装列表</p>
            <p></p>
            <p>
                其他信息
                (传感器信息（加速度、重力、陀螺仪传感器)、sim卡激活信息)
            </p>
            <p></p>
            <p>使用目的：</p>
            <p></p>
            <p>广告投放、广告归因、反作弊、安全、广告交互（摇摇，滑动等)</p>
            <p></p>
            <p>隐私协议地址：https://u.kuaishou.com/home/detail/1220</p>
            <p></p>
            <p>7.3 第三方SDK名称：优量汇 SDK</p>
            <p></p>
            <p>运营方：深圳市腾讯计算机系统有限公司</p>
            <p></p>
            <p>收集信息类型：</p>
            <p></p>
            <p>
                粗略位置信息
                (基站、附近的WIFI、连接的WIFI第三方开发者可以选择是否向本SDK提供如下信息：粗略位置信息)
            </p>
            <p></p>
            <p>
                设备/网络/系统信息
                (设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、时区、网络类型、运营商、磁力、加速度、重力、陀螺仪传感器)
            </p>
            <p></p>
            <p>标识符 (OAID、IMEI、Android_ID)</p>
            <p></p>
            <p>应用信息 (宿主应用的包名、版本号)</p>
            <p></p>
            <p>使用目的：</p>
            <p></p>
            <p>广告投放、广告归因、广告监测、反作弊等</p>
            <p></p>
            <p>
                隐私协议地址：https://e.qq.com/dev/help_detail.html?app_id=1&cid=2005&pid=5983
            </p>
            <p></p>
        </div>
    </div>
</template>

<script>
export default {
    name: "yinsi",
};
</script>

<style scoped></style>
